import { atom } from 'recoil';

const KEY = 'taxAccountAtom';

export default atom({
  key: KEY,
  default: null,
});
